<template>
  <v-flex xs12>
    <template v-if="content.url">
      <template v-if="!isMobile">
        <v-card height="72vh" style="overflow-y: hidden">
          <div
            style="width: 100%; height: 100%; overflow-y: scroll; -webkit-overflow-scrolling: touch;"
          >
            <iframe
              type="application/pdf"
              v-on:load="loaded = true"
              v-show="loaded"
              style="min-height: 100%; min-width: 100%;"
              :src="content.url"
            />
            <div v-if="!loaded">
              <v-skeleton-loader :key="index" v-for="index in 5" type="article" />
            </div>
          </div>
        </v-card>
      </template>
      <template v-else>
        <v-card
          style="border-radius: 10px; cursor: pointer"
          flat
          color="#dddddd"
          class="pa-5 my-2"
          @click.stop="didTapDownloadFile"
        >
          <v-layout justify-center align-center column>
            <v-btn @click.stop="didTapDownloadFile" fab color="primary" class="mb-2">
              <v-icon>file_download</v-icon>
            </v-btn>
            <span class="primary--text">{{"Obter PDF"}}</span>
          </v-layout>
        </v-card>
      </template>
    </template>
    <v-hover>
      <template v-slot:default="{ hover }">
        <v-card
          style="border-radius: 10px; cursor: pointer"
          flat
          :color="hover ? '#dddddd' : 'background'"
          class="pa-5 my-2"
          @click.stop="didTapFileInput"
        >
          <v-layout justify-center align-center column>
            <input
              id="contentFileInput"
              name="myFile"
              type="file"
              accept="application/pdf"
              @change="didChangeFile"
            />
            <v-btn @click.stop="didTapFileInput" fab color="primary" class="mb-2">
              <v-icon>file_upload</v-icon>
            </v-btn>
            <span class="primary--text">{{content.url ? "Substituir arquivo" : "Enviar arquivo"}}</span>
          </v-layout>
        </v-card>
      </template>
    </v-hover>
    <UploadDialogs
      :is-uploading="uploading"
      :upload-progress="progress"
      :show-snackbar="snackbar"
      :upload-name="uploadName"
      :upload-size="uploadSize"
      @hideSnackbar="snackbar = false"
      @didTapCancel="didTapCancel"
    />
  </v-flex>
</template>

<script>
import { updateContent } from "@/firebase/api/content";
import UploadDialogs from "@/components/dialogs/PhotoUpload";
import FileUploadMixin from "@/mixins/fileupload";

export default {
  mixins: [FileUploadMixin],
  components: { UploadDialogs },
  data: () => ({
    loaded: false,
    snackbar: false
  }),
  props: {
    content: Object
  },
  computed: {
    uploadOnChange() {
      return true;
    },
    fileinputID() {
      return "contentFileInput";
    },
    filepath() {
      return `chapters/${this.$route.params.chapterID}/contents/${this.$route.params.contentID}.pdf`;
    },
    isMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];

      return toMatch.some(toMatchItem => {
        return navigator.userAgent.match(toMatchItem);
      });
    }
  },
  methods: {
    didTapDownloadFile() {
      window.open(this.content.url);
    },
    async uploadFinished(uploadURL) {
      this.uploading = false;
      this.file = null;
      this.previewFile = null;
      this.snackbar = true;
      this.progress = 0;
      updateContent(
        this.$route.params.chapterID,
        this.$route.params.contentID,
        {
          url: uploadURL
        }
      );
    }
  }
};
</script>
